import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getExchangesInfo } from "../../redux/exchange/actions";

function UseFetchExchanges() {
  const {
    main: { userData },
    exchangeState: {
      exchangesInfo,
      exchangesLoading,
      exchangesError,
      exchanges,
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !Object.keys(exchangesInfo).length &&
      !exchangesLoading &&
      !exchangesError &&
      userData?.email
    ) {
      dispatch(getExchangesInfo());
    }
  }, [
    dispatch,
    exchangesError,
    exchangesInfo,
    exchangesLoading,
    userData?.email,
  ]);

  return { exchanges, loading: exchangesLoading };
}

export default UseFetchExchanges;
